import Vue from 'vue'
const vm = new Vue({
	data() {
		return {
			fps: 0,
			animationAvailable: true
		}
	}
})

export class Animation {

	private animations: {[key: number]: (elapsed: number) => void} = {}
	private id = 0

	private frameTime = 0
	private frameCount = 0

	private previousTimestamp = 0
	private animationID: null | number = null
	private boundAnimate: (timestamp: number) => void

	constructor() {
		this.boundAnimate = this.animate.bind(this)
		document.addEventListener('visibilitychange', () => {
			vm.animationAvailable = !document.hidden
		})
	}

	get fps() {
		return vm.fps
	}

	get animationAvailable() {
		return vm.animationAvailable
	}

	get animationRunning() {
		return this.animationAvailable && this.animationID !== null
	}

	add(animation: (ms: number) => void): number {
		this.id++
		this.animations[this.id] = animation

		if(this.animationID === null) {
			this.startAnimation()
		}

		return this.id
	}

	remove(id: number) {
		delete this.animations[id]
	}

	removeAll() {
		this.animations = {}
	}

	start() {
		if(!this.animationID) {
			this.startAnimation()
		}
	}

	stop() {
		if(this.animationID) {
			window.cancelAnimationFrame(this.animationID)
			this.animationID = null
			this.resetFrameCount()
		}
	}

	private startAnimation() {
		this.previousTimestamp = performance.now()
		this.animationID = window.requestAnimationFrame(this.boundAnimate)
	}

	private resetFrameCount() {
		this.frameCount = 0
		this.frameTime = 0
		vm.fps = 0
	}

	private animate(timestamp: number) {
		const elapsed = timestamp - this.previousTimestamp
		this.previousTimestamp = timestamp

		// count fps
		this.frameCount++
		this.frameTime += elapsed
		if(this.frameTime >= 1000) {
			vm.fps = this.frameCount
			this.frameCount = 0
			this.frameTime = 0
		}

		// run all animations
		const animations = Object.keys(this.animations)
		if(animations.length) {
			animations.forEach(id => this.animations[id](elapsed))
			this.animationID = window.requestAnimationFrame(this.boundAnimate)
		} else {
			this.resetFrameCount()
			this.animationID = null
		}
	}

}

export const AnimationService = {
	install: (Vue, options) => {
		Vue.prototype.$animation = new Animation()
	}
}
